import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import Main from '../../components/Main/Main';
import Title from '../../components/Title';
import FileButton from './FileButton';
import {
  Button,
  ButtonGroup,
  Card,
  Chip,
  List,
  ListItem,
  ListItemSuffix,
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
  Typography,
} from '@material-tailwind/react';
import { useDispatch, useSelector } from 'react-redux';
import {
  cadastroProductCsv,
  getMarcas,
  products,
  resetProduct,
  updateProductCsv,
} from '../../slices/productSlice';
import useGetCategoria from '../../hook/useGetCategoria';
import { ChevronDown } from 'lucide-react';
import ButtonImgUpload from '../../components/ButtonImgUpload';
import { criticidade, estoque, undMedida } from '../Cadastros/Produto/Produto';
import MsgInputError from '../../components/MsgInputError';
import Hr from '../../components/Hr';
import { convertErrorCsv } from './convertErrorCsv';
import usePageTitle from '../../hook/usePageTitle';

const colsCadastro = [
  'categoria',
  'marcaDeCompra',
  'tipoEstoque',
  'unidadeMedida',
  'criticidade',
  'produto',
  'winthor',
  'local',
  'descricao',
  'img',
];

const conlAtualizar = ['WINTHOR', 'QUANTIDADE'];

const CadastroCsv = () => {
  usePageTitle();
  const dispatch = useDispatch();
  const { marcas, loading, success, error, productos } = useSelector((state) => state.product);
  const { result } = useGetCategoria();
  const [infoScv, setInfoScv] = useState(colsCadastro);
  const [info, setInfo] = useState(null);
  const [reset, setReset] = useState(false);
  const [successCsv, setSuccessCsv] = useState(false);

  useEffect(() => {
    if (success) {
      setSuccessCsv(true);
    }
  }, [success]);

  useEffect(() => {
    return () => dispatch(products());
  }, [dispatch]);

  const handleReset = () => {
    setReset(true);
    setTimeout(() => {
      setReset(false);
    }, 1000);
  };

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    watch,
    formState: { errors },
  } = useForm();
  const file = watch('file');

  useEffect(() => {
    clearErrors();
    dispatch(resetProduct());
    setSuccessCsv(false);
  }, [file]);

  const handleActivaInfoCadastro = () => {
    setInfoScv(colsCadastro);
    setInfo(null);
  };

  const handleActivaInfoAtualizar = () => {
    setInfoScv(conlAtualizar);
    setInfo(null);
  };

  useEffect(() => {
    dispatch(getMarcas());
  }, []);

  const handleInfoActive = (info) => {
    setInfo(info);
  };

  const searchLastNoWinthor = () => {
    const winthor = productos.find((produto) => produto.winthor.length === 3);
    return winthor.winthor;
  };

  const onUpdate = (data) => {
    const formData = new FormData();
    formData.append('file', data.file[0]);
    dispatch(updateProductCsv(formData));
    handleReset();
  };

  const onCadastro = (data) => {
    const formData = new FormData();
    formData.append('file', data.file[0]);
    if (data.fotos) {
      Array.from(data.fotos).forEach((file) => {
        formData.append('fotos', file);
      });
    }
    const winthor = searchLastNoWinthor();
    formData.append('lastWinthor', winthor);
    dispatch(cadastroProductCsv(formData));
    handleReset();
  };

  return (
    <Main>
      <Title>Cadastrar/Atualizar : CSV</Title>
      <div className="w-full sm:w-[50%] space-y-2 mx-auto mb-2">
        <FileButton setValue={setValue} formCamp="file" register={register} reset={reset} />
        {errors?.file && <MsgInputError text={'Este campo é obrigatório'} />}
        <ButtonImgUpload multi setValue={setValue} formCamp="fotos" reset={reset} />
        {loading && (
          <Button loading color="white">
            Aguarde...
          </Button>
        )}
        {!loading && (
          <ButtonGroup color="green">
            <Button onClick={handleSubmit(onCadastro)}>Cadastrar</Button>
            <Button onClick={handleSubmit(onUpdate)}>Atualizar</Button>
          </ButtonGroup>
        )}
        {successCsv && (
          <Typography className="text-amber-400 font-extrabold uppercase">Concluido !!!</Typography>
        )}
        {error && (
          <Button
            onClick={() => convertErrorCsv(error)}
            color="red"
            className="text-white font-extrabold uppercase"
          >
            Erros clique aqui para baixar
          </Button>
        )}
      </div>
      <Hr />
      <div className="flex flex-col overflow-auto sm:overflow-hidden">
        <div className="w-[100%] mx-auto flex flex-col gap-5 items-center">
          <ButtonGroup variant="gradient" color="white">
            <Button onClick={handleActivaInfoCadastro}>Cadastrar</Button>
            <Button onClick={handleActivaInfoAtualizar}>Atualizar</Button>
          </ButtonGroup>
          <Typography variant="h4" color="white" className="text-center">
            Colunas necessarias
          </Typography>
          <div className="flex gap-2 flex-wrap items-center justify-center">
            {infoScv.map((item) => (
              <Button variant="filled" color="amber" onClick={() => handleInfoActive(item)}>
                {item}
              </Button>
            ))}
          </div>
        </div>
        <div className="flex justify-center mt-5  overflow-auto">
          {info === 'marcaDeCompra' && (
            <Card className="mt-2 md:w-96 overflow-auto">
              <Typography color="black" variant="h5" className="text-center font-extrabold">
                Marcas de compra
              </Typography>
              <div className="overflow-auto h-96">
                <List>
                  <ListItem disabled>
                    <Typography className="text-red-500 font-extrabold uppercase">Nome</Typography>
                    <ListItemSuffix>
                      <Chip
                        value="ID"
                        variant="ghost"
                        size="sm"
                        className="rounded-full"
                        color="red"
                      />
                    </ListItemSuffix>
                  </ListItem>
                  {marcas?.length > 0 &&
                    marcas.map((marca) => (
                      <ListItem key={marca.nome}>
                        <Typography className="text-black font-normal uppercase">
                          {marca.nome}
                        </Typography>
                        <ListItemSuffix>
                          <Chip
                            value={marca.id}
                            variant="ghost"
                            size="sm"
                            className="rounded-full"
                          />
                        </ListItemSuffix>
                      </ListItem>
                    ))}
                </List>
              </div>
            </Card>
          )}
          {info === 'categoria' && (
            <Card className="md:w-96 h-full">
              <Typography color="black" variant="h5" className="text-center font-extrabold">
                Categoria de compra
              </Typography>
              <div className="overflow-auto h-[90%]">
                <List>
                  {result?.length > 0 &&
                    result.map((categoria) => (
                      <Menu>
                        <MenuHandler>
                          <Button
                            variant="text"
                            className="flex text-black justify-between gap-3 text-base font-normal capitalize tracking-normal"
                          >
                            {categoria.nome}
                            <ChevronDown />
                          </Button>
                        </MenuHandler>
                        <MenuList className="w-96">
                          {categoria.categorias.map((item) => (
                            <MenuItem className="flex items-center">
                              <Typography className="text-black font-normal uppercase">
                                {item.nome}
                              </Typography>
                              <ListItemSuffix>
                                <Chip
                                  value={item.id}
                                  variant="ghost"
                                  size="sm"
                                  className="rounded-full"
                                />
                              </ListItemSuffix>
                            </MenuItem>
                          ))}
                        </MenuList>
                      </Menu>
                    ))}
                </List>
              </div>
            </Card>
          )}
          {info === 'tipoEstoque' && (
            <Card className="md:w-96 overflow-auto h-[98%]">
              <Typography color="black" variant="h5" className="text-center font-extrabold">
                Tipo de estoque
              </Typography>
              <div className="overflow-auto h-[90%]">
                <List>
                  {estoque.map((estoque) => (
                    <ListItem key={estoque.nome}>
                      <Typography className="text-black font-normal uppercase">
                        {estoque.nome}
                      </Typography>
                      <ListItemSuffix>
                        <Chip
                          value={estoque.id}
                          variant="ghost"
                          size="sm"
                          className="rounded-full"
                        />
                      </ListItemSuffix>
                    </ListItem>
                  ))}
                </List>
              </div>
            </Card>
          )}
          {info === 'criticidade' && (
            <Card className="md:w-96 overflow-auto h-[98%]">
              <Typography color="black" variant="h5" className="text-center font-extrabold">
                Criticidade
              </Typography>
              <div className="overflow-auto h-[90%]">
                <List>
                  {criticidade.map((criticidade) => (
                    <ListItem key={criticidade.nome}>
                      <Typography className="text-black font-normal uppercase">
                        {criticidade.nome}
                      </Typography>
                      <ListItemSuffix>
                        <Chip
                          value={criticidade.id}
                          variant="ghost"
                          size="sm"
                          className="rounded-full"
                        />
                      </ListItemSuffix>
                    </ListItem>
                  ))}
                </List>
              </div>
            </Card>
          )}
          {info === 'unidadeMedida' && (
            <Card className="md:w-96 overflow-auto h-[98%]">
              <Typography color="black" variant="h5" className="text-center font-extrabold">
                UNIDADE DE MEDIDA
              </Typography>
              <div className="overflow-auto h-[90%]">
                <List>
                  {undMedida.map((undMedida) => (
                    <ListItem key={undMedida.nome}>
                      <Typography className="text-black font-normal uppercase">
                        {undMedida.nome}
                      </Typography>
                      <ListItemSuffix>
                        <Chip
                          value={undMedida.id}
                          variant="ghost"
                          size="sm"
                          className="rounded-full"
                        />
                      </ListItemSuffix>
                    </ListItem>
                  ))}
                </List>
              </div>
            </Card>
          )}
        </div>
      </div>
    </Main>
  );
};

export default CadastroCsv;
